import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getShipName } from "../Actions/ShipViewAPI";
import { getShipnameList } from "../Actions/HelpersAPI";
import { getVisitorSearchList } from "../Actions/VisitorManagement";
import swal from "sweetalert";
import axios from "axios";
import API from "../helpers/api";
import logo from "../Asset/download.jpg";
import Role from "../helpers/role";
import Autocomplete from "react-autocomplete";
import "../App.css";
import { getAllRank } from "../Actions/RankManagementAPI";
import { toast } from "react-toastify";

let searchData = {
  shipId: 0,
  PageNumber: 1,
  isPass: false,
  showAllResult: true,
  PageSize: 25,
  shipName: "",
  fromDate: "",
  toDate: "",
}
let userRole = localStorage.getItem("UserRoles");

class AddVisitorMember extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      attachmentName: "",
      user: JSON.parse(localStorage.getItem("currentUser")),
      PhotoFile: "",
      searchData: {
        shipName: "",
        /* shipId: 0, */
        crewId: "",
        name: "",
        designation: "",
        photo: "",
        photoName: "",
        createdBy: "",
        isVisitor: true,
        visitorId: 0
      },

    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputFileChange = this.handleInputFileChange.bind(this);
  }
  componentDidMount() {
    const { dispatch, match } = this.props;
    this.props.dispatch(getShipnameList());
    this.props.dispatch(getShipName());
    this.props.dispatch(getAllRank());
    dispatch({ type: "SubBannerTitle", data: "Visitor Management" });
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    const { shipInfo, visitorDetails, dispatch } = nextProps;
    if (visitorDetails && visitorDetails !== "") {
      prevState.PhotoFile = visitorDetails.photo;
      prevState.searchData.visitorId = parseInt(visitorDetails.visitorId);
      prevState.searchData.photo = visitorDetails.photo;
      if (visitorDetails.photoName !== null) {
        prevState.searchData.photoName = visitorDetails.photoName;
      }
      dispatch({ type: "VisitorUserDetails", data: "" });
    }
  }
  handleInputChange(e) {
    this.state.searchData[e.target.name] = e.target.value;
    this.setState({});
  }

  handleInputFileChange(event) {
    let _this = this;
    let file = event?.target?.files[0];
    let filename = event?.target?.files[0].name;
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      let finalResult = reader?.result.split(",");
      _this.state.PhotoFile = reader?.result;
      _this.state.searchData["photo"] = finalResult[1];
      _this.state.searchData["photoName"] = filename;
      _this.setState({});
    };
  }
  SubmitVisitor = () => {
    const { dispatch, history, shipInfo } = this.props;
    if (this.state.searchData.crewId !== "" && this.state.searchData.name !== "" && this.state.searchData.designation !== "") {
      let data = {
        shipName:
          userRole == Role.mmpladmin
            ? this.state.searchData.shipName
            : shipInfo.shipName,
        crewId: this.state.searchData.crewId,
        name: this.state.searchData.name,
        designation: this.state.searchData.designation,
        photo: this.state.searchData.photo,
        photoName: this.state.searchData.photoName,
        isVisitor: true,
        visitorId: this.state.searchData.visitorId,
        createdBy: this.state.user.email,
      };

      let url = `${API.PostVisitor}`;
      axios
        .post(url, data)
        .then((response) => {
          if (response?.status === 500) {
            swal("Error!", "Error when adding the data. Try again.", "warning");
          } else {
            if (response?.status === 200) {
              toast.success("Visitor Added Successfully", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
              dispatch(getVisitorSearchList(searchData, 1));
              history.push("/Home/Management/VisitorManagement");
            }
          }
        })
        .catch((error) => {
          swal("Error!", "Something went wrong. Please try again.", "warning");
          console.log("Error in Add new Visitor" + error);
        });
    }
    else {
      swal('Error!', 'Please fill the details', 'warning')
    }
  };

  ClearInput = () => {
    this.state.searchData.photoName = "";
    this.state.searchData.photo = "";
    this.state.PhotoFile = "";
    this.setState({});
  };

  renderShipNameTitle(state, val) {
    return (state?.shipName || "").toLowerCase().indexOf((val || "").toLowerCase()) !== -1;
  }

  renderRankTitle(state, val) {
    return (state?.rankName || "").toLowerCase().indexOf((val || "").toLowerCase()) !== -1;
  }

  handleAnnualSearchChange = (e) => {
    const { dispatch } = this.props;
    this.state.searchData.shipName = e.target.value;
    this.setState({});
  };

  handleAnnualSelectChange = (e, id) => {
    const { dispatch } = this.props;
    this.state.searchData.shipName = e;
    /* this.state.searchData.shipId = id; */
    this.setState({});
  };

  handleAnnualRankSearchChange = (e) => {
    const { dispatch } = this.props;
    this.state.searchData.designation = e.target.value;
    this.setState({});
  };

  handleAnnualRankSelectChange = (e, id) => {
    const { dispatch } = this.props;
    let url = `${API.RankExist}?rankId=${id}`;
    console.log("url", url)
    axios.get(url)
      .then((response) => {
        if (response.data === false) {
          this.state.searchData.designation = e;
          this.setState({});
        }
        else {
          toast.error("Rank already used", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        dispatch({
          type: "getRankExistSuccess",
          data: response.data
        })
      })
      .catch((error) => {
        dispatch({
          type: "getRankExistFailure",
          error: "ERROR"
        })
      })
  };
  BacktoPrevious() {
    this.props.history.goBack();
  }

  render() {
    const { ShipNameList, showSidePane, AllRank } = this.props;
    let ScreenWidth = window.innerWidth;
    /* console.log("width", ScreenWidth); */
    // let user = JSON.parse(localStorage.getItem("currentUser"));
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row px-3 pb-3">
            <button
              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
              onClick={() => this.BacktoPrevious()}
            >
              <div style={{ position: 'relative' }}>
                <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Back</span>
              </div>
            </button>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="panel-box">
                <div
                  className="card MM-card-header mt-2 mb-0"
                  style={{ backgroundColor: "white", border: "0px" }}
                >
                  <div className="card-body">
                    <h5
                      className="card-title ml-4 mt-2"
                      style={{ color: "092a51" }}
                    >
                      Add New Visitor
                    </h5>
                  </div>
                </div>
                <div className="search-filter-box">
                  <div className="row pb-3">
                    <div className="col-sm-2 m-auto text-right">
                      <div className="text-center rounded-circle">
                        <img
                          src={
                            this.state.PhotoFile &&
                              this.state.PhotoFile !== ""
                              ? this.state.PhotoFile
                              : logo
                          }
                          alt="Smiley face"
                          style={{ width: "145px", height: "140px" }}
                          class="rounded-circle"
                        ></img>
                      </div>
                    </div>
                    <div className="col-sm-10">
                      <div className="row">
                        <div className={showSidePane ? "col-lg-4 " : "col-lg-4 "}>
                          <label className="form-label">Crew Id</label>
                          <br></br>
                          <input
                            className="form-control"
                            type="text"
                            name="crewId"
                            placeholder="Crew Id"
                            value={this.state.searchData.crewId}
                            onChange={(e) => this.handleInputChange(e)}
                          ></input>
                        </div>
                        <div className={showSidePane ? "col-lg-4 " : "col-lg-4 "}>
                          <label className="form-label">Name</label>
                          <br></br>
                          <input
                            className="form-control"
                            type="text"
                            name="name"
                            placeholder="Name"
                            value={this.state.searchData.name}
                            onChange={(e) => this.handleInputChange(e)}
                          ></input>
                        </div>
                        {userRole == Role.mmpladmin && (
                          <div
                            className={showSidePane ? "col-lg-4 " : "col-lg-4 "}
                          >
                            <div
                              className="autocomplete-wrappers"
                            /* style={{ zIndex: 9999 }} */
                            >
                              <label className="form-label">Ship Name</label>
                              <br></br>
                              <Autocomplete
                                contentEditable={true}
                                value={this.state.searchData.shipName}
                                inputProps={{
                                  placeholder: "Ship Name",
                                }}
                                items={ShipNameList ?? []}
                                getItemValue={(item) => item.shipName}
                                shouldItemRender={this.renderShipNameTitle.bind(
                                  this
                                )}
                                renderMenu={(item) => (
                                  <div className="dropdown">{item}</div>
                                )}
                                renderItem={(item, isHighlighted) => (
                                  <div
                                    className={`items ${isHighlighted ? "selected-items" : ""
                                      }`}
                                  >
                                    {item.shipName}
                                  </div>
                                )}
                                onChange={(e) => this.handleAnnualSearchChange(e)}
                                onSelect={(e, item) => this.handleAnnualSelectChange(e, item.shipID)}
                              />
                            </div>
                          </div>
                        )}

                        <div
                          className={showSidePane ? "col-lg-4 " : "col-lg-4 "}
                        >
                          <div
                            className="autocomplete-wrappers"
                            style={{ zIndex: 9999 }}
                          >
                            <label className="form-label">Rank</label>
                            <br></br>
                            <Autocomplete
                              contentEditable={true}
                              value={this.state.searchData.designation}
                              inputProps={{
                                placeholder: "Rank",
                              }}
                              items={AllRank ?? []}
                              getItemValue={(item) => item.rankName}
                              shouldItemRender={this.renderRankTitle.bind(
                                this
                              )}
                              renderMenu={(item) => (
                                <div className="dropdown">{item}</div>
                              )}
                              renderItem={(item, isHighlighted) => (
                                <div
                                  className={`items ${isHighlighted ? "selected-items" : ""
                                    }`}
                                >
                                  {item.rankName}
                                </div>
                              )}
                              onChange={(e) => this.handleAnnualRankSearchChange(e)}
                              onSelect={(e, item) => this.handleAnnualRankSelectChange(e, item.rankId)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <label className="form-label">Photo</label>
                          <br></br>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">
                                Browse File
                                <input
                                  type="file"
                                  id="files"
                                  title=" "
                                  style={{ marginRight: 40 }}
                                  onChange={(e) => this.handleInputFileChange(e)}
                                  onClick={(event) => {
                                    event.currentTarget.value = null;
                                  }}
                                />
                              </span>
                            </div>
                            <input
                              type="text"
                              class="form-control"
                              placeholder=""
                              name="username"
                              value={this.state.searchData.photoName}
                            />
                            {this.state.searchData.photoName ? (
                              <div class="input-group-append"
                                style={{ cursor: "pointer" }}>
                                <i
                                  class="fa fa-times input-group-text"
                                  aria-hidden="true"
                                  onClick={() => this.ClearInput()}
                                ></i>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                        <div className={userRole == Role.staff ? "col-lg-8 pt-3" : "col-lg-4 pt-3"}>
                          <br></br>
                          <div
                            className="search-btn-col"
                            style={{ textAlign: "end" }}
                          >
                            <button
                              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                              type="submit"
                              onClick={() => this.SubmitVisitor()}
                            >
                              {" "}
                              Submit{" "}
                            </button>
                            <button
                              className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                              type="button"
                              onClick={() => this.hideSidePanel()}
                            >
                              {" "}
                              Cancel{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  hideSidePanel = () => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/Management/VisitorManagement");
  };
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    ShipNameList: state.UserManageReducer.ShipNameList,
    shipInfo: state.SidePanReducer.shipInfo,
    AllRank: state.RankManagementReducer.AllRank,
    VisitorIdList: state.VisitorManagementReducer.VisitorIdList,
    visitorDetails: state.VisitorManagementReducer.VisitorUserDetails,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddVisitorMember)
);
